export enum RequestVersionChangeField {
	SbaLegalAnalysis = "SBA_LEGAL_ANALYSIS",
	SbaRecommendation = "SBA_RECOMMENDATION",
	SbaRecommendationReasons = "SBA_RECOMMENDATION_REASONS",
	SbaClassifications = "SBA_CLASSIFICATIONS",
	SbaAttachments = "SBA_ATTACHMENTS",
	Priority = "PRIORITY",
	RequestData = "REQUEST_DATA",
}
